module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1002.52a73fe4.png";